import {Component, Inject} from '@angular/core';
import {NavController, ModalController, AlertController} from 'ionic-angular';
import {AngularFire, FirebaseRef, FirebaseListObservable, FirebaseObjectObservable} from 'angularfire2';
import {TranslatePipe, TranslateService} from "ng2-translate/ng2-translate";


@Component({
  templateUrl: 'build/pages/eta/eta.html',
  pipes: [TranslatePipe]
})
export class EtaPage {
  gps: FirebaseObjectObservable<any>;
  trayectos: FirebaseListObservable<any[]>;
  idSalida: number;
  latLngBus: google.maps.LatLng;
  latLngParada: google.maps.LatLng;

  constructor(@Inject(FirebaseRef) public ref: Firebase, public af: AngularFire, public alertCtrl: AlertController, public translate: TranslateService) {
    this.trayectos = af.database.list('/trayectos');
  }

   onSubmit(form) {
    this.idSalida = form.idSalida;
    
    this.ref.child('gps').once('value', snapshot => {
      let bus: number;
      if (this.idSalida == 6 || this.idSalida == 7) {
        bus = 2;
      } else {
        bus = 1;
      }

      if ((bus == 1 && snapshot.val().bus1.update != 'error') || (bus == 2 && snapshot.val().bus2.update != 'error')) {
        this.gps = this.af.database.object('/gps/bus' + bus);
        this.gps.update({ update: true });
        this.ref.child('gps/bus' + bus + '/update').on('value', snapshot => {
          // Si update = false tras cambiarlo a true es porque ya se ha actualizado la ubicacion y podemos procesarla
          if (snapshot.val() == false) {
            this.busOnRoute(form.idSalida, bus);
          } else if (snapshot.val() == 'error') {
            this.translate.get("no_bus").subscribe(value => {
              this.doAlert(value);
            });
          }
        });
      } else {
        this.translate.get("no_bus").subscribe(value => {
          this.doAlert(value);
        });
      }
    });
  }

  busOnRoute(idSalida, bus) {
    this.ref.child('gps/bus' + bus).once('value', snapshot => {
      let direction = snapshot.val().direction;
      let nextStop = snapshot.val().nextStop;

      if (bus == 1) {
        if (direction == 5 && nextStop > idSalida) {
          this.translate.get("no_bus").subscribe(value => {
            this.doAlert(value);
          });
        } else if (direction == 0 && nextStop < idSalida) {
          this.translate.get("no_bus").subscribe(value => {
            this.doAlert(value);
          });
        } else {
          this.calculateETA(idSalida, bus);
        }
      } else if (bus == 2) {
        if (direction == 5 && nextStop < idSalida) {
          this.translate.get("no_bus").subscribe(value => {
            this.doAlert(value);
          });
        } else if (direction == 7 && nextStop > idSalida) {
          this.translate.get("no_bus").subscribe(value => {
            this.doAlert(value);
          });
        } else {
          this.calculateETA(idSalida, bus);
        }
      }
    });
  }
  
  calculateETA(idSalida, bus) {
    this.ref.once('value', snapshot => {
      // Obtenemos las coordenadas del autobus
      let gpsRef = snapshot.child('gps/bus' + bus);
      let latLngBus = new google.maps.LatLng(gpsRef.val().lat, gpsRef.val().lng);

      // Obtenemos las coordenadas de la parada seleccionada
      let paradaRef = snapshot.child('trayectos').child(idSalida.toString());
      let latLngParada = new google.maps.LatLng(paradaRef.val().lat, paradaRef.val().lng);

      // Calculamos el tiempo de llegada
      let service = new google.maps.DistanceMatrixService();
      service.getDistanceMatrix({
        origins: [latLngBus],
        destinations: [latLngParada],
        travelMode: google.maps.TravelMode.DRIVING,
      }, (response, status) => {
          if (status == google.maps.DistanceMatrixStatus.OK) {
            let element = response.rows[0].elements[0];
            this.doAlert(element.duration.text + " aprox.");
          } else {
            this.translate.get("no_bus").subscribe(value => {
              this.doAlert(value);
            });
          }
        });
      });
  }

  doAlert(text: string) {
    this.translate.get("eta_long").subscribe(value => {
      let alert = this.alertCtrl.create({
        title: value,
        subTitle: text,
        buttons: ['OK']
      });
      alert.present();
    });
  }

}
